module.exports = __webpack_public_path__ + "static/littleWomen9s-2dc92411b6267d38b4e22ecc0feba619.jpg";